import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import transactionService from '../services/transactionService';

const TransactionsPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);

  const fetchTransactions = async () => {
    try {
      const data = await transactionService.getAll();
      setTransactions(data);
    } catch (error) {
      toast.error('İşlemler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);

  const handleDelete = async (id) => {
    if (window.confirm('Bu işlemi silmek istediğinize emin misiniz?')) {
      try {
        await transactionService.delete(id);
        toast.success('İşlem silindi.');
        fetchTransactions();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  const filteredTransactions = transactions.filter(t => 
    t.company_name?.toLocaleLowerCase('tr-TR').includes(searchTerm.toLocaleLowerCase('tr-TR'))
  );

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Borç & Alacak Hareketleri</h2>
        <Link to="/transactions/new" className="btn btn-primary">
          <FaPlus className="me-2" /> Yeni İşlem Ekle
        </Link>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Cari adı ile ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Cari Adı</th>
                  <th>Tip</th>
                  <th>Tutar</th>
                  <th>Vade Tarihi</th>
                  <th>Durum</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td>{transaction.company_name}</td>
                    <td>
                      <span className={`badge ${transaction.transaction_type === 'alacak' ? 'bg-success' : 'bg-danger'}`}>
                        {transaction.transaction_type === 'alacak' ? 'Alacak' : 'Borç'}
                      </span>
                    </td>
                    <td>{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(transaction.amount)}</td>
                    <td>{transaction.due_date ? new Date(transaction.due_date).toLocaleDateString('tr-TR') : '-'}</td>
                    <td>
                      <span className={`badge ${
                        transaction.status === 'odendi' ? 'bg-success' : 
                        transaction.status === 'bekliyor' ? 'bg-warning' : 'bg-secondary'
                      }`}>
                        {transaction.status}
                      </span>
                    </td>
                    <td>
                      <Link to={`/transactions/edit/${transaction.id}`} className="btn btn-sm btn-outline-primary me-2">
                        <FaEdit />
                      </Link>
                      <button onClick={() => handleDelete(transaction.id)} className="btn btn-sm btn-outline-danger">
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredTransactions.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center">Kayıtlı işlem bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Görünüm */}
          <div className="d-md-none">
            {filteredTransactions.map((transaction) => (
              <div className="card mb-3 shadow-sm" key={transaction.id}>
                <div className="card-body" onClick={() => toggleRow(transaction.id)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-0 fw-bold">{transaction.company_name}</h6>
                      <span className={`badge ${transaction.transaction_type === 'alacak' ? 'bg-success' : 'bg-danger'}`}>
                        {transaction.transaction_type === 'alacak' ? 'Alacak' : 'Borç'}
                      </span>
                    </div>
                    <div className="text-end">
                      <div className="fw-bold">{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(transaction.amount)}</div>
                      <small className="text-muted">{expandedRow === transaction.id ? <FaChevronUp /> : <FaChevronDown />}</small>
                    </div>
                  </div>

                  {expandedRow === transaction.id && (
                    <div className="mt-3 border-top pt-3">
                      <p className="mb-1"><strong>Vade:</strong> {transaction.due_date ? new Date(transaction.due_date).toLocaleDateString('tr-TR') : '-'}</p>
                      <p className="mb-1"><strong>Durum:</strong> 
                        <span className={`badge ms-2 ${
                          transaction.status === 'odendi' ? 'bg-success' : 
                          transaction.status === 'bekliyor' ? 'bg-warning' : 'bg-secondary'
                        }`}>
                          {transaction.status}
                        </span>
                      </p>
                      <div className="d-flex justify-content-end gap-2 mt-3">
                        <Link to={`/transactions/edit/${transaction.id}`} className="btn btn-sm btn-outline-primary">
                          <FaEdit /> Düzenle
                        </Link>
                        <button onClick={(e) => { e.stopPropagation(); handleDelete(transaction.id); }} className="btn btn-sm btn-outline-danger">
                          <FaTrash /> Sil
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsPage;